import {PropsWithChildren, useState, lazy, Suspense, startTransition} from 'react';
import {useNavigate} from "react-router-dom";
import merge from "lodash/merge";
import {Button, Container, Icon, Modal, useIcons} from '@yosmanyga/rich-ui';
import {Introduction, Welcome} from '@yosmanyga/fortaleza-core';
import {ThemeProvider} from '@yosmanyga/theme';
import {ManuscriptLayout} from '../ManuscriptLayout';
import buttonLeftBg from '../assets/images/button-left-bg.png';
import buttonRightBg from '../assets/images/button-right-bg.png';
import buttonCenterBg from '../assets/images/button-center-bg.png';

const HCaptcha = lazy(() => import('@hcaptcha/react-hcaptcha'));

const WelcomeScreen = () => {
    const navigate = useNavigate();
    const icons = useIcons();

    const [introduction, setIntroduction] = useState(true);

    const [human, setHuman] = useState(
        // window.location.hostname === 'localhost' || false
        true
    );

    return <>
        <Welcome
            enabled={human}
            templates={{
                outerLayout: ({children}) => {
                    return <Container
                        width='100%'
                        flex={1}
                        flow="column"
                        align={{
                            main: 'center',
                            cross: 'center',
                        }}
                    >
                        {children}
                    </Container>
                },
                languagesLayout: ({children}) => {
                    return <Container
                        flow="row"
                        align={{
                            main: 'flex-end',
                        }}
                        position={{
                            type: 'absolute',
                            top: 0,
                            right: 0,
                        }}
                    >
                        {children}
                    </Container>
                },
                headerLayout: ({children}: PropsWithChildren) => {
                    return <ThemeProvider
                        build={(variables, prev) => {
                            return merge(
                                {},
                                prev && prev(variables),
                                {
                                    text: {
                                        header_intent: {
                                            font: {
                                                size: '140%',
                                            }
                                        },
                                        subheader_intent: {
                                            font: {
                                                size: '80%',
                                            }
                                        },
                                    },
                                }
                            );
                        }}
                        variables={undefined}
                    >
                        <Container
                            flow="column"
                            align={{
                                cross: 'center',
                            }}
                        >
                            {children}
                        </Container>
                    </ThemeProvider>
                },
                manuscriptLayout: ({children, ...props}) => {
                    return <>
                        <ThemeProvider
                            build={(variables, prev) => {
                                return merge(
                                    {},
                                    prev && prev(variables),
                                    {
                                        button: {
                                            primary_intent: {
                                                pseudo: {
                                                    hover: {
                                                        background:
                                                            `${buttonLeftBg} left no-repeat, ` +
                                                            `${buttonRightBg} right no-repeat, ` +
                                                            `${buttonCenterBg} center repeat-x`,
                                                    },
                                                },
                                            }
                                        },
                                    }
                                );
                            }}
                            variables={undefined}
                        >
                            <ManuscriptLayout
                                footer={true}
                                {...props}
                            >
                                {children}
                            </ManuscriptLayout>
                        </ThemeProvider>
                        {!human && <form>
                            <Suspense fallback={<></>}>
                                <HCaptcha
                                    sitekey="587759fd-05f3-4dbb-8027-4850a044b3a6"
                                    onVerify={() => {
                                        startTransition(() => {
                                            setHuman(true);
                                        });
                                    }}
                                    // size='invisible'
                                />
                            </Suspense>
                        </form>}
                    </>
                },
            }}
            onLogin={async () => {
                navigate('/')
            }}
            onIntroduction={async () => {
                setIntroduction(true)
            }}
        />
        {introduction && <Introduction
            templates={{
                layout: ({children}) => {
                    return <ThemeProvider
                        build={(variables, prev) => {
                            return merge(
                                {},
                                prev && prev(variables),
                                {
                                    text: {
                                        quote_intent: {
                                            font: {
                                                size: '80%',
                                            }
                                        },
                                        signature_intent: {
                                            font: {
                                                size: '120%',
                                            }
                                        },
                                    },
                                }
                            );
                        }}
                        variables={undefined}
                    >
                        <Modal
                            onClose={() => {
                                setIntroduction(false);
                            }}
                        >
                            <Container intent="modal_body">
                                <Container
                                    flow='row'
                                    align={{
                                        main: 'flex-end'
                                    }}
                                    width='auto'
                                >
                                    <Button
                                        onClick={() => {
                                            setIntroduction(false);
                                        }}
                                    >
                                        <Icon
                                            component={icons.actions.close}
                                            size='xs'
                                        />
                                    </Button>
                                </Container>
                                {children}
                            </Container>
                        </Modal>
                    </ThemeProvider>
                }
            }}
            onLogin={async () => {
                navigate('/')
            }}
        />}
    </>
};

export {WelcomeScreen};
